import {
	startOfMonth,
	endOfMonth,
	startOfYear,
	endOfYear,
	previousMonday,
	previousSunday,
	lastDayOfWeek,
	isMonday,
	startOfYesterday,
} from 'date-fns'

const date = new Date()

// TOOLS
const getDayShift = () => 7 - new Date(new Date().getFullYear(), 0, 1).getDay()

// WEEK
export const getToday = () => date

export const getYesterday = () => startOfYesterday()

// WEEK
export const getFirstDayOfThisWeek = () => {
	if (isMonday(date)) {
		return date
	}
	return previousMonday(date)
}

export const getLastDayOfThisWeek = () => lastDayOfWeek(new Date(), { weekStartsOn: 1 })

export const getFirstDayOfLastWeek = () => {
	const sunday = previousSunday(new Date())
	return previousMonday(sunday)
}

export const getLastDayOfLastWeek = () => previousSunday(new Date())

// MONTH
export const getFirstDayOfThisMonth = () => startOfMonth(new Date())

export const getLastDayOfThisMonth = () => endOfMonth(new Date())

export const getFirstDayOfLastMonth = () => startOfMonth(new Date(new Date().getFullYear(), new Date().getMonth() - 1))

export const getLastDayOfLastMonth = () => endOfMonth(new Date(new Date().getFullYear(), new Date().getMonth() - 1))

// Quarter
export const getQuarter = () => Math.floor(getToday().getMonth() / 3)

export const getFirstDayOfThisQuarter = () => new Date(getToday().getFullYear(), getQuarter() * 3, 1)

export const getLastDayOfThisQuarter = () => {
	const firstDayOfThisQuarter = getFirstDayOfThisQuarter()
	return new Date(firstDayOfThisQuarter.getFullYear(), firstDayOfThisQuarter.getMonth() + 3, 0)
}

export const getFirstDayOfLastQuarter = () => new Date(getToday().getFullYear(), getQuarter() * 3 - 3, 1)

export const getLastDayOfLastQuarter = () => {
	const firstDayOfLastQuarter = getFirstDayOfLastQuarter()
	return new Date(firstDayOfLastQuarter.getFullYear(), firstDayOfLastQuarter.getMonth() + 3, 0)
}

// YEAR
export const getFirstDayOfThisYear = () => startOfYear(date)

export const getLastDayOfThisYear = () => endOfYear(date)

export const getFirstDayOfLastYear = () => startOfYear(new Date().setFullYear(new Date().getFullYear() - 1))

export const getLastDayOfLastYear = () => endOfYear(new Date().setFullYear(new Date().getFullYear() - 1))

// LOCALIZATION
export const getWeekdays = (lang = 'en') =>
	Array.from({ length: 7 }, (_, i) =>
		new Date(new Date().getFullYear(), 0, i + 1 + getDayShift()).toLocaleDateString(lang, { weekday: 'long' }),
	)

export const getWeekdaysShorts = (lang = 'en') =>
	Array.from({ length: 7 }, (_, i) =>
		new Date(new Date().getFullYear(), 0, i + 1 + getDayShift()).toLocaleDateString(lang, { weekday: 'short' }),
	)

export const getWeekdaysMin = (lang = 'en') =>
	Array.from({ length: 7 }, (_, i) =>
		new Date(new Date().getFullYear(), 0, i + 1 + getDayShift()).toLocaleDateString(lang, { weekday: 'narrow' }),
	)

export const getMonthsShorts = (lang = 'en') =>
	Array.from({ length: 12 }, (_, i) =>
		new Date(new Date().getFullYear(), i + 1, 0).toLocaleDateString(lang, { month: 'short' }),
	)

export const getMonths = (lang = 'en') =>
	Array.from({ length: 12 }, (_, i) =>
		new Date(new Date().getFullYear(), i + 1, 0).toLocaleDateString(lang, { month: 'long' }),
	)
